import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { api } from '../api/client';

type Aviso = {
  id: number;
  titulo: string;
  tipo: string | null;
  imagen_url: string | null;
  publicado_en: string;
  vence_en: string | null;
  area: string | null;
  leido: boolean;
};

function fmtFecha(s: string) {
  return new Date(s.replace(' ', 'T')).toLocaleDateString('es-AR', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

const TIPO_COLOR: Record<string, string> = {
  alerta:     '#dc2626',
  comunicado: '#2563eb',
  noticia:    '#10b981',
  aviso:      '#d97706',
};

export default function Avisos() {
  const nav = useNavigate();
  const [items, setItems]     = useState<Aviso[]>([]);
  const [cargando, setCargando] = useState(true);
  const [err, setErr]         = useState<string | null>(null);

  useEffect(() => {
    api<{ items: Aviso[] }>('/avisos')
      .then((d) => setItems(d.items))
      .catch((e) => setErr(e.message))
      .finally(() => setCargando(false));
  }, []);

  return (
    <>
      <TopBar title="Avisos" back />
      <main className="max-w-md mx-auto px-4 py-4 pb-24 space-y-3">
        {cargando && <p className="text-center text-gray-400 pt-10">Cargando…</p>}
        {err && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">{err}</div>
        )}
        {!cargando && items.length === 0 && (
          <div className="text-center py-14">
            <p className="text-4xl mb-3">📭</p>
            <p className="text-gray-500 text-sm">No hay avisos publicados.</p>
          </div>
        )}
        {items.map((a) => {
          const color = TIPO_COLOR[a.tipo ?? ''] ?? '#6b7280';
          return (
            <button
              key={a.id}
              onClick={() => nav(`/avisos/${a.id}`)}
              className="w-full text-left bg-white border border-app rounded-xl overflow-hidden shadow-sm active:bg-gray-50 flex"
            >
              {a.imagen_url && (
                <img
                  src={a.imagen_url}
                  alt=""
                  className="w-24 object-cover flex-shrink-0"
                  style={{ minHeight: 80 }}
                />
              )}
              <div className="flex-1 px-3 py-3 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  {!a.leido && (
                    <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: '#32329f' }} />
                  )}
                  {a.tipo && (
                    <span
                      className="text-xs font-bold px-2 py-0.5 rounded-full"
                      style={{ backgroundColor: color + '20', color }}
                    >
                      {a.tipo.charAt(0).toUpperCase() + a.tipo.slice(1)}
                    </span>
                  )}
                </div>
                <p className={`text-sm leading-snug text-gray-900 ${!a.leido ? 'font-bold' : 'font-semibold'}`}>
                  {a.titulo}
                </p>
                <p className="text-xs text-gray-400 mt-1">
                  {a.area ? `${a.area} · ` : ''}{fmtFecha(a.publicado_en)}
                </p>
              </div>
              <span className="pr-3 flex items-center text-gray-300 text-lg flex-shrink-0">›</span>
            </button>
          );
        })}
      </main>
    </>
  );
}
